import { gql } from 'graphql-request'

export const UPLOAD_FILE = gql`
  mutation UploadBookCover($file: Upload!) {
    UploadBookCover(file: $file) {
      filePath
    }
  }
`
